import React,{useState,useEffect} from 'react'
import { useParams } from 'react-router-dom'
import styled from 'styled-components'
import { TextBody, Container, ImageDetail, Title, WrappDetail, WrappRecomendation, DescriptionSide, Box, Span, Wrapper } from '../../globalStyle'
import Footer from '../footer/footer'
import Navbar from '../navbar/Navbar'
import Not from '../../assets/images/notfound.svg'
import LeftArrow from '../left-arrow/arrow'
import ImageError from '../error/error'
import { url } from '../../App'

function DetailProjects(){
    const stateData = {
        nama :"",
        body : "",
        image: Not
    }

    const {id} = useParams();
    const [ data, setData ] = useState(stateData);
    console.log(data)
    const [ data2, setData2 ] = useState([]);
    const [loading, setLoading] = useState(false)
    const [error,setError] = useState(false)

    useEffect(() => {
        const ProjectDetail = async() =>{
            setLoading(true)
            try{
                let res = await fetch(`${url}/project/${id}`)
                let data = await res.json()
                setData(data.data)
            }catch(error){
                setError(true)
            }finally{
                setLoading(false)
            }
        }
        ProjectDetail()
        return()=>{
            ProjectDetail()
        }
    },[id])

    useEffect(() => {
    const getProject = async() => {
            setLoading(true)
            try{
                let projects = await fetch(`${url}/get-project`)
                let data2 = await projects.json()
                setData2(data2.data)
            }catch(error){
                setError(true)
            }finally{
                setLoading(false)
            }
        }
        getProject()

        return()=>{
            getProject()
        }
    },[])
    
   if(error){
       return(
           <ImageError />
       )
   }
//    if(loading){
//        return(
//            <p>Mohon Tunggu Sebentar.</p>
//        )
//    }
   
    return(
        <>
        <Container>
            <Wrapper>
            <WrappDetail>
                    <ImageDetail src={data ? data.image : Not} alt="Image" />
                    <Title>{data ? data.nama : "Mohon Maaf Data Tidak tersedia !"}</Title>
                    <TextBody>{data ? data.body : ""}</TextBody>
            </WrappDetail>
            <WrappRecomendation>
                <p>Rekomendasi : </p>
                {
                    data &&
                    data2.map(item=>{
                        return(
                            item.image ==  data.image ? null : (
                                <Box to={'/projects/'+item.id} key={item.id}>
                                    <img src={item.image} width={240} alt="Image data 2" /> 
                                    <DescriptionSide>{item.body.substr(0,40) + '...'}</DescriptionSide>
                                    <Span />
                                </Box>
                            )
                        )
                    })
                }
            </WrappRecomendation>
            </Wrapper>
        </Container>
        </>
    )
}
export default DetailProjects 